import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchFlowRewardBanner } from "actions/account/subscription";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import Image from "components/image";
import ProgressTracker from "./progress-tracker";
import { CUSTOMER_STATE } from "utils/constants";
import { formatTitle } from "helpers/format-title";

const FlowRewardBanner = () => {
	const [response, setResponse] = useState();
	const { subscriptionId, isFetched } = useSelector(state => state.account.subscription);
	const { customerState } = useSelector(state => state.account.profile);
	const [isLoading, setIsLoading] = useState(true);
	const { subscriptionSettings: { flowRewards } } = useGlobalContext();
	const dispatch = useDispatch();

	useEffect(() => {
		if (customerState === CUSTOMER_STATE.Logged_out || (!subscriptionId && isFetched)) {
			setIsLoading(false);
		}
	}, [subscriptionId, customerState, isFetched]);

	useEffect(() => {
		if (!subscriptionId) return;

		dispatch(fetchFlowRewardBanner()).then((res) => {
			setResponse(res);
		}).finally(() => {
			if (isLoading)
				setIsLoading(false);
		});
	}, [subscriptionId]);


	if (isLoading)
		return (
			<div className="h-[232px] lg:h-[162px] flow-reward-banner animate-pulse" />
		);

	if (!response?.text || (!subscriptionId && isFetched)) return null;

	const data = flowRewards.find(item => response.text.includes(item.id));

	if (!data) return null;

	return (
		<div className="flow-reward-banner">
			<div className="flex flex-col gap-y-5 lg:w-1/2 hd-screen-max-width">
				<div className="flex items-center gap-x-5">
					{data.icon && <span className="size-12"><Image image={data.icon} /></span>}
					<h4>{formatTitle(data.title)}</h4>
				</div>
				{data.subtitle && <p>{data.subtitle}</p>}
			</div>
			<ProgressTracker progress={data.progress} icon={data.icon} />
		</div>
	);
};

export default FlowRewardBanner;